import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {SignaalkaartenComponent} from './signaalkaarten/signaalkaarten.component';
import {SignaalkaartComponent} from './signaalkaart/signaalkaart.component';
import {SignaalkaartHeaderComponent} from './signaalkaart-header/signaalkaart-header.component';
import {SignaalkaartVraagComponent} from './signaalkaart/vraag/signaalkaart-vraag.component';
import {SignaalkaartAntwoordenComponent} from './signaalkaart-antwoorden/signaalkaart-antwoorden.component';
import { SignaalkaartAntwoordHeaderComponent } from './signaalkaart-antwoord-header/signaalkaart-antwoord-header.component';

@NgModule({
  declarations: [
    SignaalkaartenComponent,
    SignaalkaartComponent,
    SignaalkaartVraagComponent,
    SignaalkaartHeaderComponent,
    SignaalkaartAntwoordenComponent,
    SignaalkaartAntwoordHeaderComponent,
  ],
  imports: [
    CoreModule,
  ],
  exports: [
    SignaalkaartenComponent,
    SignaalkaartComponent,
    SignaalkaartHeaderComponent,
    SignaalkaartAntwoordenComponent,
    SignaalkaartAntwoordHeaderComponent,
  ],
})
export class SignaalkaartModule {
}
